import _ from "lodash";

// import * as utils from "../utils/utils.js";
// import jsonTemplateMinimal from "../data/template-minimal.js";

// let variables = [];
// let variablesMap = {};
/*
Transform from activity json to entities in memory
*/
// export function transformToActivityEntities(activity, identityId = null) {
// 	variables = [];
// 	variablesMap = {};
// 	let activityEntities = {};
// 	let dstChildren = [];


// 	let driveRootPath = activity.hasOwnProperty("driveRootPath") ? activity.driveRootPath : "";
// 	if (_.isEmpty(driveRootPath) && !_.isEmpty(activity.name)) {
// 		driveRootPath = _.replace(_.replace(activity.name, /\s+/g, "-"), /-+/g, "-");
// 	}

// 	let root = {
// 		revision: activity.hasOwnProperty("revision") ? activity.revision : 1,
// 		id: activity.id,
// 		baseIds: activity.hasOwnProperty("baseIds") ? activity.baseIds : [],
// 		cloned: activity.cloned,
// 		publisher: activity.publisher,
// 		entity: {
// 			entityId: "root",
// 			activityId: activity.hasOwnProperty("activityId") ? activity.activityId : "",
// 			type: "activity",
// 			label: activity.name,
// 			labelAlexaPlain: activity.hasOwnProperty("nameAlexaPlain") ? activity.nameAlexaPlain : "",
// 			labelAlexaRich: activity.hasOwnProperty("nameAlexaRich") ? activity.nameAlexaRich : "",
// 			labelAudio: activity.hasOwnProperty("nameAudio") ? activity.nameAudio : "",
// 			labelSsml: activity.hasOwnProperty("nameSsml") ? activity.nameSsml : "",
// 			labelPrint: activity.hasOwnProperty("namePrint") ? activity.namePrint : "",
// 			description: activity.description,
// 			backgroundImage: activity.hasOwnProperty("backgroundImage") ? activity.backgroundImage : "",
// 			video: activity.hasOwnProperty("video") ? activity.video : "",
// 			image: activity.hasOwnProperty("image") ? activity.image : "",
// 			audio: activity.hasOwnProperty("audio") ? activity.audio : "",
// 			pdf: activity.hasOwnProperty("pdf") ? activity.pdf : "",
// 			heroImage: activity.hasOwnProperty("heroImage") ? activity.heroImage : "",
// 			driveRootPath,
// 			genre: activity.genre,
// 			tags: activity.tags,
// 			contributors: activity.hasOwnProperty("contributors") ? activity.contributors : [],
// 			startInShowMode: activity.hasOwnProperty("startInShowMode") ? activity.startInShowMode : false,
// 			allowSwitchToShowMode: activity.hasOwnProperty("allowSwitchToShowMode") ? activity.allowSwitchToShowMode : false,
// 			suppressAudio: activity.hasOwnProperty("suppressAudio") ? activity.suppressAudio : false,

// 			trackLocation: activity.hasOwnProperty("trackLocation") ? activity.trackLocation : false,
// 			uploadAndOptimizeMediaFile: activity.hasOwnProperty("uploadAndOptimizeMediaFile") ? activity.uploadAndOptimizeMediaFile : false,
// 			dataSources: activity.hasOwnProperty("dataSources") ? activity.dataSources : [],
// 			externalResources: activity.hasOwnProperty("externalResources") ? activity.externalResources : [],
// 			suppressPrint: activity.hasOwnProperty("suppressPrint") ? activity.suppressPrint : false,
// 			submitLabel: activity.hasOwnProperty("submitLabel") ? activity.submitLabel : "Save + Exit",
// 			lockOnSubmit: activity.hasOwnProperty("lockOnSubmit") ? activity.lockOnSubmit : false,
// 			submitLabelWhenComplete: activity.hasOwnProperty("submitLabelWhenComplete") ? activity.submitLabel : "Save + Exit",
// 			lockOnSubmitWhenComplete: activity.hasOwnProperty("lockOnSubmitWhenComplete") ? activity.lockOnSubmit : false,
// 			functions: activity.hasOwnProperty("functions") ? activity.functions : "",
// 			contentModel: activity.hasOwnProperty("contentModel") ? activity.contentModel : ""
// 		},
// 		expanded: true,
// 		selected: false,
// 		children: dstChildren
// 	};

// 	if (identityId) {
// 		root.entity.identityId = identityId;
// 	}

// 	activityEntities.root = root;
// 	activityEntities.variables = variables;
// 	activityEntities.variablesMap = variablesMap;
// 	activityEntities.children = dstChildren;
// 	recurseActivity(activity.children, dstChildren);

// 	return activityEntities;
// }

// function recurseActivity(arr, dstChildren) {
// 	for (let i = 0; i < arr.length; i++) {
// 		let newChildren = [];
// 		const entityId = utils.generateUUID();
// 		if (arr[i].type === "list") {

// 			const node = {
// 				id: utils.generateUUID(),
// 				expanded: false,
// 				selected: false,
// 				entity: {
// 					entityId,
// 					id: arr[i].hasOwnProperty("id") ? arr[i].id : "",
// 					groupNames: arr[i].hasOwnProperty("groupNames") ? arr[i].groupNames : [],
// 					filterTags: arr[i].hasOwnProperty("filterTags") ? arr[i].filterTags : [],
// 					type: "list",
// 					label: arr[i].name,
// 					labelAlexaPlain: arr[i].hasOwnProperty("nameAlexaPlain") ? arr[i].nameAlexaPlain : "",
// 					labelAlexaRich: arr[i].hasOwnProperty("nameAlexaRich") ? arr[i].nameAlexaRich : "",
// 					labelAudio: arr[i].hasOwnProperty("nameAudio") ? arr[i].nameAudio : "",
// 					labelSsml: arr[i].hasOwnProperty("nameSsml") ? arr[i].nameSsml : "",
// 					labelPrint: arr[i].hasOwnProperty("namePrint") ? arr[i].namePrint : "",
// 					defaultView: arr[i].defaultView,
// 					color: arr[i].color,
// 					backgroundColor: arr[i].hasOwnProperty("backgroundColor") ? arr[i].backgroundColor : "#888888",
// 					borderColor: arr[i].hasOwnProperty("borderColor") ? arr[i].borderColor : "#888888",
// 					iconColor: arr[i].hasOwnProperty("iconColor") ? arr[i].iconColor : "#ffffff",
// 					backgroundImage: arr[i].hasOwnProperty("backgroundImage") ? arr[i].backgroundImage : "",
// 					video: arr[i].hasOwnProperty("video") ? arr[i].video : "",
// 					image: arr[i].hasOwnProperty("image") ? arr[i].image : "",
// 					audio: arr[i].hasOwnProperty("audio") ? arr[i].audio : "",
// 					pdf: arr[i].hasOwnProperty("pdf") ? arr[i].pdf : "",
// 					//suppressAudio: arr[i].hasOwnProperty("suppressAudio")?arr[i].suppressAudio:false,
// 					suppressPrint: arr[i].hasOwnProperty("suppressPrint") ? arr[i].suppressPrint : false,
// 					ignoreCompletion: arr[i].hasOwnProperty("ignoreCompletion") ? arr[i].ignoreCompletion : false,
// 					enabled: arr[i].hasOwnProperty("enabled") ? arr[i].enabled : true,
// 					visible: arr[i].hasOwnProperty("visible") ? arr[i].visible : true,
// 					conditionalVisible: arr[i].hasOwnProperty("conditionalVisible") ? arr[i].conditionalVisible : "",
// 					iconType: arr[i].hasOwnProperty("iconType") ? arr[i].iconType : "none",					
// 					iconImage: arr[i].hasOwnProperty("iconImage") ? arr[i].iconImage : "",
// 					iconFa: arr[i].hasOwnProperty("iconFa") ? arr[i].iconFa : ""
// 				},
// 				children: newChildren
// 			};

// 			dstChildren.push(node);
// 		} else if (arr[i].type === "section") {
// 			const node = {
// 				id: utils.generateUUID(),
// 				expanded: false,
// 				selected: false,
// 				entity: {
// 					entityId,
// 					id: arr[i].hasOwnProperty("id") ? arr[i].id : "",
// 					groupNames: arr[i].hasOwnProperty("groupNames") ? arr[i].groupNames : [],
// 					filterTags: arr[i].hasOwnProperty("filterTags") ? arr[i].filterTags : [],
// 					type: "section",
// 					label: arr[i].name,
// 					labelAlexaPlain: arr[i].hasOwnProperty("nameAlexaPlain") ? arr[i].nameAlexaPlain : "",
// 					labelAlexaRich: arr[i].hasOwnProperty("nameAlexaRich") ? arr[i].nameAlexaRich : "",
// 					labelAudio: arr[i].hasOwnProperty("nameAudio") ? arr[i].nameAudio : "",
// 					labelSsml: arr[i].hasOwnProperty("nameSsml") ? arr[i].nameSsml : "",
// 					labelPrint: arr[i].hasOwnProperty("namePrint") ? arr[i].namePrint : "",
// 					color: arr[i].hasOwnProperty("color") ? arr[i].color : "#ffffff",
// 					backgroundColor: arr[i].hasOwnProperty("backgroundColor") ? arr[i].backgroundColor : "#888888",
// 					borderColor: arr[i].hasOwnProperty("borderColor") ? arr[i].borderColor : "#888888",
// 					iconColor: arr[i].hasOwnProperty("iconColor") ? arr[i].iconColor : "#ffffff",
// 					backgroundImage: arr[i].hasOwnProperty("backgroundImage") ? arr[i].backgroundImage : "",
// 					video: arr[i].hasOwnProperty("video") ? arr[i].video : "",
// 					image: arr[i].hasOwnProperty("image") ? arr[i].image : "",
// 					audio: arr[i].hasOwnProperty("audio") ? arr[i].audio : "",
// 					pdf: arr[i].hasOwnProperty("pdf") ? arr[i].pdf : "",
// 					//suppressAudio: arr[i].hasOwnProperty("suppressAudio")?arr[i].suppressAudio:false,
// 					suppressPrint: arr[i].hasOwnProperty("suppressPrint") ? arr[i].suppressPrint : false,
// 					ignoreCompletion: arr[i].hasOwnProperty("ignoreCompletion") ? arr[i].ignoreCompletion : false,
// 					enabled: arr[i].hasOwnProperty("enabled") ? arr[i].enabled : true,
// 					visible: arr[i].hasOwnProperty("visible") ? arr[i].visible : true,
// 					conditionalVisible: arr[i].hasOwnProperty("conditionalVisible") ? arr[i].conditionalVisible : ""
// 				},
// 				children: newChildren
// 			};

// 			dstChildren.push(node);
// 		} else if (arr[i].type.startsWith("item")) {
// 			let node = {
// 				id: utils.generateUUID(),
// 				expanded: false,
// 				selected: false,
// 				entity: {
// 					entityId,
// 					id: arr[i].hasOwnProperty("id") ? arr[i].id : "",
// 					groupNames: arr[i].hasOwnProperty("groupNames") ? arr[i].groupNames : [],
// 					filterTags: arr[i].hasOwnProperty("filterTags") ? arr[i].filterTags : [],
// 					type: arr[i].type,
// 					backgroundColor: arr[i].hasOwnProperty("backgroundColor") ? arr[i].backgroundColor : "transparent",
// 					label: arr[i].hasOwnProperty("label1") ? arr[i].label1 : "",
// 					label1AlexaPlain: arr[i].hasOwnProperty("label1AlexaPlain") ? arr[i].label1AlexaPlain : "",
// 					label1AlexaRich: arr[i].hasOwnProperty("label1AlexaRich") ? arr[i].label1AlexaRich : "",
// 					label1Audio: arr[i].hasOwnProperty("label1Audio") ? arr[i].label1Audio : "",
// 					label1Ssml: arr[i].hasOwnProperty("label1Ssml") ? arr[i].label1Ssml : "",
// 					label1Print: arr[i].hasOwnProperty("label1Print") ? arr[i].label1Print : "",
// 					color: arr[i].hasOwnProperty("color") ? arr[i].color : "#000000",
// 					label2: arr[i].hasOwnProperty("label2") ? arr[i].label2 : "",
// 					label2AlexaPlain: arr[i].hasOwnProperty("label2AlexaPlain") ? arr[i].label2AlexaPlain : "",
// 					label2AlexaRich: arr[i].hasOwnProperty("label2AlexaRich") ? arr[i].label2AlexaRich : "",
// 					label2Audio: arr[i].hasOwnProperty("label2Audio") ? arr[i].label2Audio : "",
// 					label2Ssml: arr[i].hasOwnProperty("label2Ssml") ? arr[i].label2Ssml : "",
// 					label2Print: arr[i].hasOwnProperty("label2Print") ? arr[i].label2Print : "",
// 					label2Color: arr[i].hasOwnProperty("label2Color") ? arr[i].label2Color : "#000000",
// 					mandatory: arr[i].hasOwnProperty("mandatory") ? arr[i].mandatory : false,
// 					comments: arr[i].hasOwnProperty("comments") ? arr[i].comments : "",
// 					commentsInline: arr[i].hasOwnProperty("commentsInline") ? arr[i].commentsInline : false,
// 					commentsAuthor: "",
// 					commentsAudio: arr[i].hasOwnProperty("commentsAudio") ? arr[i].commentsAudio : "",
// 					commentsSsml: arr[i].hasOwnProperty("commentsSsml") ? arr[i].commentsSsml : "",
// 					commentsPrint: arr[i].hasOwnProperty("commentsPrint") ? arr[i].commentsPrint : "",
// 					commentsTemplate: arr[i].hasOwnProperty("commentsTemplate") ? arr[i].commentsTemplate : "",
// 					commentsDataPath: arr[i].hasOwnProperty("commentsDataPath") ? arr[i].commentsDataPath : "",
// 					linkOnCheck: arr[i].hasOwnProperty("linkOnCheck") ? arr[i].linkOnCheck : false,
// 					linkId: arr[i].hasOwnProperty("linkId") ? arr[i].linkId : "",
// 					linkActionType: arr[i].hasOwnProperty("linkActionType") ? arr[i].linkActionType : "goto",
// 					valueTrigger: arr[i].hasOwnProperty("valueTrigger") ? arr[i].valueTrigger : "",
// 					backgroundImage: arr[i].hasOwnProperty("backgroundImage") ? arr[i].backgroundImage : "",
// 					video: arr[i].hasOwnProperty("video") ? arr[i].video : "",
// 					image: arr[i].hasOwnProperty("image") ? arr[i].image : "",
// 					audio: arr[i].hasOwnProperty("audio") ? arr[i].audio : "",
// 					pdf: arr[i].hasOwnProperty("pdf") ? arr[i].pdf : "",
// 					//suppressAudio: arr[i].hasOwnProperty("suppressAudio")?arr[i].suppressAudio:false,
// 					suppressPrint: arr[i].hasOwnProperty("suppressPrint") ? arr[i].suppressPrint : false,
// 					ignoreCompletion: arr[i].hasOwnProperty("ignoreCompletion") ? arr[i].ignoreCompletion : false,
// 					startTracking: arr[i].hasOwnProperty("startTracking") ? arr[i].startTracking : false,
// 					stopTracking: arr[i].hasOwnProperty("stopTracking") ? arr[i].stopTracking : false,
// 					startNamedTimers: arr[i].hasOwnProperty("startNamedTimers") ? arr[i].startNamedTimers : [],
// 					stopNamedTimers: arr[i].hasOwnProperty("stopNamedTimers") ? arr[i].stopNamedTimers : [],						
// 					useAsSessionName: arr[i].hasOwnProperty("useAsSessionName") ? arr[i].useAsSessionName : false,
// 					isSearchable: arr[i].hasOwnProperty("isSearchable") ? arr[i].isSearchable : false,
// 					enabled: arr[i].hasOwnProperty("enabled") ? arr[i].enabled : true,
// 					visible: arr[i].hasOwnProperty("visible") ? arr[i].visible : true,
// 					conditionalVisible: arr[i].hasOwnProperty("conditionalVisible") ? arr[i].conditionalVisible : "",
// 					calculatedDefaultValue: arr[i].hasOwnProperty("calculatedDefaultValue") ? arr[i].calculatedDefaultValue : "",
// 					pickerItemsDatasource: arr[i].hasOwnProperty("pickerItemsDatasource") ? arr[i].pickerItemsDatasource : "",
// 					"_validation_pickerItemsDatasource": arr[i].hasOwnProperty("_validation_pickerItemsDatasource") ? arr[1]["_validation_pickerItemsDatasource"] : ""
// 				}

// 			};

// 			if (arr[i].hasOwnProperty("id") && arr[i].id !== "") {
// 				variables.push({
// 					id: arr[i].id,
// 					entityId
// 				});
// 				variablesMap[entityId] = true;
// 			}

// 			let deltaProps = {};
// 			switch (arr[i].type) {
// 			case "item":
// 				deltaProps = {
// 					entity: {
// 						labelOnly: arr[i].hasOwnProperty("labelOnly") ? arr[i].labelOnly : false,
// 						labelOnlyBackgroundColor: arr[i].hasOwnProperty("labelOnlyBackgroundColor") ? arr[i].labelOnlyBackgroundColor : "#FFF8C6",
// 						startTimer: arr[i].hasOwnProperty("startTimer") ? arr[i].startTimer : false,
// 						stopTimer: arr[i].hasOwnProperty("stopTimer") ? arr[i].stopTimer : false
// 					}
// 				};
// 				break;
// 			case "itemTextInput":
// 			case "itemTextInputMultiline":
// 				deltaProps = {
// 					entity: {
// 						textInputPlaceholder: arr[i].hasOwnProperty("textInputPlaceholder") ? arr[i].textInputPlaceholder : "",
// 						textInputDefaultValue: arr[i].hasOwnProperty("textInputDefaultValue") ? arr[i].textInputDefaultValue : "",
// 						textInputMaxLength: arr[i].hasOwnProperty("textInputMaxLength") ? arr[i].textInputMaxLength : 1000,
// 						textInputKeyboardType: arr[i].hasOwnProperty("textInputKeyboardType") ? arr[i].textInputKeyboardType : "default",
// 						textInputKeyboardAutoCapitalize: arr[i].hasOwnProperty("textInputKeyboardAutoCapitalize") ? arr[i].textInputKeyboardAutoCapitalize : "sentences",
// 						textInputKeyboardAutoCorrect: arr[i].hasOwnProperty("textInputKeyboardAutoCorrect") ? arr[i].textInputKeyboardAutoCorrect : true,
// 						textInputKeyboardReturnKeyType: arr[i].hasOwnProperty("textInputKeyboardReturnKeyType") ? arr[i].textInputKeyboardReturnKeyType : "default",
// 						textInputMaskType: arr[i].hasOwnProperty("textInputMaskType") ? arr[i].textInputMaskType : "",
// 						textInputCurrencySymbol: arr[i].hasOwnProperty("textInputCurrencySymbol") ? arr[i].textInputCurrencySymbol : "$",
// 						textInputCurrencySeparator: arr[i].hasOwnProperty("textInputCurrencySeparator") ? arr[i].textInputCurrrencySeparator : ",",
// 						textInputNumberOfLines: arr[i].hasOwnProperty("textInputNumberOfLines") ? arr[i].textInputNumberOfLines : 4
// 					}
// 				};
// 				break;
// 			case "itemPicker":
// 				deltaProps = {
// 					entity: {
// 						pickerItemViewType: arr[i].hasOwnProperty("pickerItemViewType") ? arr[i].pickerItemViewType : "picker",
// 						pickerItemsDatasource: arr[i].hasOwnProperty("pickerItemsDatasource") ? arr[i].pickerItemsDatasource : "",
// 						pickerItemPlaceholder: arr[i].hasOwnProperty("pickerItemPlaceholder") ? arr[i].pickerItemPlaceholder : "",
// 						pickerItemDefaultValue: arr[i].pickerItemDefaultValue,
// 						pickerItems: arr[i].pickerItems,
// 						pickerAdvanceOnSelect: arr[i].hasOwnProperty("pickerAdvanceOnSelect") ? arr[i].pickerAdvanceOnSelect : false,
// 						pickerLinkOnSelect: arr[i].hasOwnProperty("pickerLinkOnSelect") ? arr[i].pickerLinkOnSelect : false,
// 						pickerLinkActionType: arr[i].hasOwnProperty("pickerLinkActionType") ? arr[i].pickerLinkActionType : "goto"
// 					}
// 				};
// 				break;
// 			case "itemChoiceSingle":
// 			case "itemChoiceMulti":
// 				deltaProps = {
// 					entity: {
// 						choiceItems: arr[i].choiceItems
// 					}
// 				};
// 				break;
// 			case "itemYesNo":
// 				deltaProps = {
// 					entity: {
// 						yesNoLinkOnSelect: arr[i].hasOwnProperty("yesNoLinkOnSelect") ? arr[i].yesNoLinkOnSelect : false,
// 						yesNoLinkActionType: arr[i].hasOwnProperty("yesNoLinkActionType") ? arr[i].yesNoLinkActionType : "goto",
// 						yesNoYesLinkId: arr[i].hasOwnProperty("yesNoYesLinkId") ? arr[i].yesNoYesLinkId : "",
// 						yesNoNoLinkId: arr[i].hasOwnProperty("yesNoNoLinkId") ? arr[i].yesNoNoLinkId : "",
// 						yesNoNaLinkId: arr[i].hasOwnProperty("yesNoNaLinkId") ? arr[i].yesNoNaLinkId : "",
// 						yesNoShowNa: arr[i].hasOwnProperty("yesNoShowNa") ? arr[i].yesNoShowNa : false,
// 					}
// 				};
// 				break;
// 			case "itemDate":
// 			case "itemTime":
// 			case "itemDateTime":
// 				deltaProps = {
// 					entity: {
// 						dateTimeType: arr[i].hasOwnProperty("dateTimeType") ? arr[i].dateTimeType : "local",
// 						dateTimeInitialDate: arr[i].hasOwnProperty("dateTimeInitialDate") ? arr[i].dateTimeInitialDate : "today",
// 						dateTimeMinuteInterval: arr[i].hasOwnProperty("dateTimeMinuteInterval") ? arr[i].dateTimeMinuteInterval : 1
// 					}
// 				};
// 				break;
// 			case "itemWeather":
// 				deltaProps = {
// 					entity: {
// 						weatherInitialLocation: arr[i].hasOwnProperty("weatherInitialLocation") ? arr[i].weatherInitialLocation : "current",
// 					}
// 				};
// 				break;
// 			case "itemBarcodeScanner":
// 				deltaProps = {
// 					entity: {
// 						barcodeTypes: arr[i].hasOwnProperty("barcodeTypes") ? arr[i].barcodeTypes : [],
// 					}
// 				};
// 				break;
// 			case "itemImagePicker":
// 				deltaProps = {
// 					entity: {
// 						imagePickerMediaType: arr[i].hasOwnProperty("imagePickerMediaType") ? arr[i].imagePickerMediaType : "photo",
// 						imagePickerAddMediaButton: arr[i].hasOwnProperty("imagePickerAddMediaButton") ? arr[i].imagePickerAddMediaButton : "Add Photo",
// 						imagePickerUploadTitle: arr[i].hasOwnProperty("imagePickerUploadTitle") ? arr[i].imagePickerUploadTitle : "Upload",
// 						imagePickerCaptureMediaTitle: arr[i].hasOwnProperty("imagePickerCaptureMediaTitle") ? arr[i].imagePickerCaptureMediaTitle : "Take Photo..."
// 					}
// 				};
// 				break;
// 			case "itemSketchPad":
// 				deltaProps = {
// 					entity: {
// 						sketchPadBackgroundColor: arr[i].hasOwnProperty("sketchPadBackgroundColor") ? arr[i].sketchPadBackgroundColor : "#ffffff",
// 						sketchPadPenColor: arr[i].hasOwnProperty("sketchPadPenColor") ? arr[i].sketchPadPenColor : "#000000",
// 						sketchPadPenWidth: arr[i].hasOwnProperty("sketchPadPenWidth") ? arr[i].sketchPadPenWidth : 5,
// 						sketchPadHeight: arr[i].hasOwnProperty("sketchPadHeight") ? arr[i].sketchPadHeight : 190
// 					}
// 				};
// 				break;
// 			default:
// 			}

// 			// Merge props
// 			node = _.merge({}, node, deltaProps);

// 			dstChildren.push(node);
// 		}

// 		if (arr[i].hasOwnProperty("children")) {
// 			recurseActivity(arr[i].children, newChildren);
// 		}
// 	}
// }

// /*
// Transform from entities in memory to activity json
// */
// export function transformFromActivityEntities(activityEntities) {
// 	let dstChildren = [];
// 	let activity = jsonTemplateMinimal;
// 	if (activityEntities.hasOwnProperty("revision")) {
// 		activityEntities.revision = activityEntities.revision + 1;
// 		activity.revision = activityEntities.revision;
// 	} else {
// 		activity.revision = 1;
// 	}
// 	activity.id = activityEntities.id;
// 	activity.baseIds = activityEntities.baseIds;
// 	activity.activityId = activityEntities.entity.activityId;
// 	activity.name = activityEntities.entity.label;
// 	activity.nameAlexaPlain = activityEntities.entity.labelAlexaPlain;
// 	activity.nameAlexaRich = activityEntities.entity.labelAlexaRich;
// 	activity.nameAudio = activityEntities.entity.labelAudio;
// 	activity.nameSsml = activityEntities.entity.labelSsml;
// 	activity.namePrint = activityEntities.entity.labelPrint;
// 	activity.description = activityEntities.entity.description;
// 	activity.genre = activityEntities.entity.genre;
// 	activity.tags = activityEntities.entity.tags;
// 	activity.contributors = activityEntities.entity.contributors;
// 	activity.children = dstChildren;
// 	activity.cloned = activityEntities.cloned;
// 	activity.publisher = activityEntities.publisher;
// 	activity.backgroundImage = activityEntities.entity.backgroundImage;
// 	activity.video = activityEntities.entity.video;
// 	activity.image = activityEntities.entity.image;
// 	activity.audio = activityEntities.entity.audio;
// 	activity.pdf = activityEntities.entity.pdf;
// 	activity.heroImage = activityEntities.entity.heroImage;
// 	activity.driveRootPath = activityEntities.entity.driveRootPath;
// 	activity.startInShowMode = activityEntities.entity.startInShowMode;
// 	activity.allowSwitchToShowMode = activityEntities.entity.allowSwitchToShowMode;
// 	activity.suppressAudio = activityEntities.entity.suppressAudio;
// 	activity.trackLocation = activityEntities.entity.trackLocation;
// 	activity.uploadAndOptimizeMediaFile = activityEntities.entity.uploadAndOptimizeMediaFile;
// 	activity.dataSources = activityEntities.entity.dataSources;
// 	activity.externalResources = activityEntities.entity.externalResources;
// 	activity.suppressPrint = activityEntities.entity.suppressPrint;
// 	if (activityEntities.entity.hasOwnProperty("identityId")) {
// 		activity.identityId = activityEntities.entity.identityId;
// 	}
// 	activity.submitLabel = activityEntities.entity.submitLabel;
// 	activity.lockOnSubmit = activityEntities.entity.lockOnSubmit;
// 	activity.submitLabelWhenComplete = activityEntities.entity.submitLabelWhenComplete;
// 	activity.lockOnSubmitWhenComplete = activityEntities.entity.lockOnSubmitWhenComplete;
// 	activity.functions = activityEntities.entity.functions;
// 	activity.contentModel = activityEntities.entity.contentModel;

// 	// TODO: Bug where "tree" has children twice
// 	recurseActivityEntities(activityEntities.children, dstChildren);

// 	return activity;
// }

// function recurseActivityEntities(arr, dstChildren) {
// 	for (let i = 0; i < arr.length; i++) {
// 		let newChildren = [];
// 		if (arr[i].entity.type === "list") {

// 			const node = {
// 				"id": arr[i].entity.id,
// 				"guid": arr[i].entity.guid,
// 				"groupNames": arr[i].entity.groupNames,
// 				"filterTags": arr[i].entity.filterTags,
// 				"type": "list",
// 				"completionState": "n",
// 				"ignoreCompletion": arr[i].entity.ignoreCompletion,
// 				"name": arr[i].entity.label,
// 				"nameAlexaPlain": arr[i].entity.labelAlexaPlain,
// 				"nameAlexaRich": arr[i].entity.labelAlexaRich,
// 				"nameAudio": arr[i].entity.labelAudio,
// 				"nameSsml": arr[i].entity.labelSsml,
// 				"namePrint": arr[i].entity.labelPrint,
// 				"defaultView": arr[i].entity.defaultView,
// 				"color": arr[i].entity.color,
// 				"iconColor": arr[i].entity.iconColor,
// 				"backgroundColor": arr[i].entity.backgroundColor,
// 				"borderColor": arr[i].entity.borderColor,
// 				"backgroundImage": arr[i].entity.backgroundImage,
// 				"video": arr[i].entity.video,
// 				"image": arr[i].entity.image,
// 				"audio": arr[i].entity.audio,
// 				"pdf": arr[i].entity.pdf,
// 				//"suppressAudio": arr[i].entity.suppressAudio,
// 				"suppressPrint": arr[i].entity.suppressPrint,
// 				"horzScrollPos": 0,
// 				"vertScrollPos": 0,
// 				"children": newChildren,
// 				"enabled": arr[i].entity.enabled,
// 				"visible": arr[i].entity.visible,
// 				"conditionalVisible": arr[i].entity.conditionalVisible,
// 				"iconType": arr[i].entity.iconType,
// 				"iconImage": arr[i].entity.iconImage,
// 				"iconFa": arr[i].entity.iconFa
// 			};

// 			dstChildren.push(node);
// 		} else if (arr[i].entity.type === "section") {
// 			const node = {
// 				"id": arr[i].entity.id,
// 				"guid": arr[i].entity.guid,
// 				"groupNames": arr[i].entity.groupNames,
// 				"filterTags": arr[i].entity.filterTags,
// 				"type": "section",
// 				"completionState": "n",
// 				"ignoreCompletion": arr[i].entity.ignoreCompletion,
// 				"name": arr[i].entity.label,
// 				"nameAlexaPlain": arr[i].entity.labelAlexaPlain,
// 				"nameAlexaRich": arr[i].entity.labelAlexaRich,
// 				"nameAudio": arr[i].entity.labelAudio,
// 				"nameSsml": arr[i].entity.labelSsml,
// 				"namePrint": arr[i].entity.labelPrint,
// 				"color": arr[i].entity.color,
// 				"backgroundColor": arr[i].entity.backgroundColor,
// 				"borderColor": arr[i].entity.borderColor,
// 				"iconColor": arr[i].entity.iconColor,
// 				"backgroundImage": arr[i].entity.backgroundImage,
// 				"video": arr[i].entity.video,
// 				"image": arr[i].entity.image,
// 				"audio": arr[i].entity.audio,
// 				"pdf": arr[i].entity.pdf,
// 				//"suppressAudio": arr[i].entity.suppressAudio,
// 				"suppressPrint": arr[i].entity.suppressPrint,
// 				"vertScrollPos": 0,
// 				"children": newChildren,
// 				"enabled": arr[i].entity.enabled,
// 				"visible": arr[i].entity.visible,
// 				"conditionalVisible": arr[i].entity.conditionalVisible
// 			};

// 			dstChildren.push(node);
// 		} else if (arr[i].entity.type.startsWith("item")) {
// 			let node = {
// 				"id": arr[i].entity.id,
// 				"guid": arr[i].entity.guid,
// 				"groupNames": arr[i].entity.groupNames,
// 				"filterTags": arr[i].entity.filterTags,
// 				"type": arr[i].entity.type,
// 				"checked": false,
// 				"ignoreCompletion": arr[i].entity.ignoreCompletion,
// 				"backgroundColor": arr[i].entity.backgroundColor,
// 				"label1": arr[i].entity.label,
// 				"label1AlexaPlain": arr[i].entity.label1AlexaPlain,
// 				"label1AlexaRich": arr[i].entity.label1AlexaRich,
// 				"label1Audio": arr[i].entity.label1Audio,
// 				"label1Ssml": arr[i].entity.label1Ssml,
// 				"label1Print": arr[i].entity.label1Print,
// 				"color": arr[i].entity.color,
// 				"label2": arr[i].entity.label2,
// 				"label2AlexaPlain": arr[i].entity.label2AlexaPlain,
// 				"label2AlexaRich": arr[i].entity.label2AlexaRich,
// 				"label2Audio": arr[i].entity.label2Audio,
// 				"label2Ssml": arr[i].entity.label2Ssml,
// 				"label2Print": arr[i].entity.label2Print,
// 				"label2Color": arr[i].entity.label2Color,
// 				"mandatory": arr[i].entity.mandatory,
// 				"comments": arr[i].entity.comments,
// 				"commentsInline": arr[i].entity.commentsInline,
// 				"commentsAuthor": arr[i].entity.commentsAuthor,
// 				"commentsAudio": arr[i].entity.commentsAudio,
// 				"commentsSsml": arr[i].entity.commentsSsml,
// 				"commentsPrint": arr[i].entity.commentsPrint,
// 				"commentsTemplate": arr[i].entity.commentsTemplate,
// 				"commentsDataPath": arr[i].entity.commentsDataPath,
// 				"linkOnCheck": arr[i].entity.linkOnCheck,
// 				"linkId": arr[i].entity.linkId,
// 				"linkActionType": arr[i].entity.linkActionType,
// 				"valueTrigger": arr[i].entity.valueTrigger,
// 				"backgroundImage": arr[i].entity.backgroundImage,
// 				"video": arr[i].entity.video,
// 				"image": arr[i].entity.image,
// 				"audio": arr[i].entity.audio,
// 				"pdf": arr[i].entity.pdf,
// 				//"suppressAudio": arr[i].entity.suppressAudio,
// 				"suppressPrint": arr[i].entity.suppressPrint,
// 				"startTracking": arr[i].entity.startTracking,
// 				"stopTracking": arr[i].entity.stopTracking,
// 				"startNamedTimers": arr[i].entity.startNamedTimers,
// 				"stopNamedTimers": arr[i].entity.stopNamedTimers,
// 				"useAsSessionName": arr[i].entity.useAsSessionName,
// 				"isSearchable": arr[i].entity.isSearchable,
// 				"enabled": arr[i].entity.enabled,
// 				"visible": arr[i].entity.visible,
// 				"conditionalVisible": arr[i].entity.conditionalVisible,
// 				"calculatedDefaultValue": arr[i].entity.calculatedDefaultValue

// 			};

// 			let deltaProps = {};
// 			switch (arr[i].entity.type) {
// 			case "item":
// 				deltaProps = {
// 					labelOnly: arr[i].entity.labelOnly,
// 					labelOnlyBackgroundColor: arr[i].entity.labelOnlyBackgroundColor,
// 					startTimer: arr[i].entity.startTimer,
// 					stopTimer: arr[i].entity.stopTimer
// 				};
// 				break;
// 			case "itemTextInput":
// 			case "itemTextInputMultiline":
// 				deltaProps = {
// 					textInputPlaceholder: arr[i].entity.textInputPlaceholder,
// 					textInputDefaultValue: arr[i].entity.textInputDefaultValue,
// 					textInputMaxLength: arr[i].entity.textInputMaxLength,
// 					textInputKeyboardType: arr[i].entity.textInputKeyboardType,
// 					textInputKeyboardAutoCapitalize: arr[i].entity.textInputKeyboardAutoCapitalize,
// 					textInputKeyboardAutoCorrect: arr[i].entity.textInputKeyboardAutoCorrect,
// 					textInputKeyboardReturnKeyType: arr[i].entity.textInputKeyboardReturnKeyType,
// 					textInputMaskType: arr[i].entity.textInputMaskType,
// 					textInputCurrencySymbol: arr[i].entity.textInputCurrencySymbol,
// 					textInputCurrencySeparator: arr[i].entity.textInputCurrencySeparator,
// 					textInputNumberOfLines: arr[i].entity.textInputNumberOfLines
// 				};
// 				break;
// 			case "itemYesNo":
// 				deltaProps = {
// 					yesNoLinkOnSelect: arr[i].entity.yesNoLinkOnSelect,
// 					yesNoLinkActionType: arr[i].entity.yesNoLinkActionType,
// 					yesNoYesLinkId: arr[i].entity.yesNoYesLinkId,
// 					yesNoNoLinkId: arr[i].entity.yesNoNoLinkId,
// 					yesNoNaLinkId: arr[i].entity.yesNoNaLinkId,
// 					yesNoShowNa: arr[i].entity.yesNoShowNa,
// 				};
// 				break;
// 			case "itemPicker":
// 				deltaProps = {
// 					pickerItemViewType: arr[i].entity.pickerItemViewType,
// 					pickerItemsDatasource: _.omit(arr[i].entity.pickerItemsDatasource, ["content"]),
// 					pickerItemPlaceholder: arr[i].entity.pickerItemPlaceholder,
// 					pickerItemDefaultValue: arr[i].entity.pickerItemDefaultValue,
// 					pickerItems: arr[i].entity.pickerItems,
// 					pickerAdvanceOnSelect: arr[i].entity.pickerAdvanceOnSelect,
// 					pickerLinkOnSelect: arr[i].entity.pickerLinkOnSelect,
// 					pickerLinkActionType: arr[i].entity.pickerLinkActionType
// 				};
// 				break;
// 			case "itemChoiceSingle":
// 			case "itemChoiceMulti":
// 				deltaProps = {
// 					choiceItems: arr[i].entity.choiceItems,
// 				};
// 				break;
// 			case "itemDate":
// 			case "itemTime":
// 			case "itemDateTime":
// 				deltaProps = {
// 					dateTimeType: arr[i].entity.dateTimeType,
// 					dateTimeInitialDate: arr[i].entity.dateTimeInitialDate,
// 					dateTimeMinuteInterval: arr[i].entity.dateTimeMinuteInterval
// 				};
// 				break;
// 			case "itemWeather":
// 				deltaProps = {
// 					weatherInitialLocation: arr[i].entity.weatherInitialLocation
// 				};
// 				break;
// 			case "itemBarcodeScanner":
// 				deltaProps = {
// 					barcodeTypes: arr[i].entity.barcodeTypes
// 				};
// 				break;
// 			case "itemImagePicker":
// 				deltaProps = {
// 					imagePickerMediaType: arr[i].entity.imagePickerMediaType,
// 					imagePickerAddMediaButton: arr[i].entity.imagePickerAddMediaButton,
// 					imagePickerUploadTitle: arr[i].entity.imagePickerUploadTitle,
// 					imagePickerCaptureMediaTitle: arr[i].entity.imagePickerCaptureMediaTitle
// 				};
// 				break;
// 			case "itemSketchPad":
// 				deltaProps = {
// 					sketchPadBackgroundColor: arr[i].entity.sketchPadBackgroundColor,
// 					sketchPadPenColor: arr[i].entity.sketchPadPenColor,
// 					sketchPadPenWidth: Number(arr[i].entity.sketchPadPenWidth),
// 					sketchPadHeight: Number(arr[i].entity.sketchPadHeight)
// 				};
// 				break;
// 			default:

// 			}


// 			// Merge props
// 			node = _.assign({}, node, deltaProps);


// 			dstChildren.push(node);
// 		}

// 		if (arr[i].hasOwnProperty("children")) {
// 			recurseActivityEntities(arr[i].children, newChildren);
// 		}
// 	}
// }


/*
Add view specific props to activity used in player
*/
export function transformToActivityPlayer(activity) {

	let activityClone = _.cloneDeep(activity);

	recurseActivityPlayer(activity, 0, activityClone.children);
	return activityClone;
}

function recurseActivityPlayer(activity, parentIndex, arr) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			//set defaults for props that are new
			if (!arr[i].hasOwnProperty("backgroundColor")) { arr[i].backgroundColor = "#cccccc"; }
			if (!arr[i].hasOwnProperty("borderColor")) { arr[i].borderColor = "#cccccc"; }
			if (!arr[i].hasOwnProperty("iconColor")) { arr[i].iconColor = "#ffffff"; }

			arr[i].expanded = false;

			//handle initial expand in ActivityPlayer.js
			/*
			let selectedListIndex = _.get(activity, "selected.listIndex");
			if (selectedListIndex === i) {
				arr[i].expanded = true;	
			} else {
				arr[i].expanded = false;
			}
			*/

		} else if (arr[i].type === "section") {

			arr[i].expanded = false;

			//handle initial expand in ActivityPlayer.js
			/*
			let selectedListIndex = _.get(activity, "selected.listIndex");
			let selectedSectionIndex = _.get(activity, "selected.sectionIndex");
			
			if (selectedListIndex === parentIndex && selectedSectionIndex === i) {
				arr[i].expanded = true;	
			} else {
				arr[i].expanded = false;	
			}
			*/
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseActivityPlayer(activity, i, arr[i].children);
		}
	}
}

/*
Strip view specific player props
*/
export function transformFromActivityPlayer(activity) {
	let activityClone = _.cloneDeep(activity);
	recurseFromActivityPlayer(activityClone.children);
	return activityClone;
}

function recurseFromActivityPlayer(arr) {
	for (let i = 0; i < arr.length; i++) {

		if (arr[i].type === "list") {
			delete arr[i].expanded;
		} else if (arr[i].type === "section") {
			delete arr[i].expanded;
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseFromActivityPlayer(arr[i].children);
		}
	}
}



